<template>
  <span>
    <v-card-title class="white--text hidden-sm-and-down">
      <v-dialog v-model="direction" temporary max-width="600px">
        <template v-slot:activator="{ on }">
          <v-btn  rounded color="indigo" v-on="on">{{ $t('map_direction') }}</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('map_location') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <div class="container">
                <div class="columns" style="padding-bottom: 0px; margin-bottom: 0px;">
                  <div class="column is-8">
                    <GmapMap
                      :center="location"
                      :options="{
                        zoomControl: true,
                        mapTypeControl: false,
                        scaleControl: false,
                        streetViewControl: false,
                        rotateControl: false,
                        fullscreenControl: true,
                        disableDefaultUi: false
                      }"
                      :zoom="14"
                      map-type-id="terrain"
                      style="width: 500px; height: 300px"
                    >
                      <GmapMarker
                        :key="'marker'+index"
                        v-for="(m, index) in markers"
                        :position="m.position"
                        :clickable="true"
                        :draggable="true"
                        @click="center=m.position"
                      />
                      <!-- <GmapCircle
                        v-for="(event, index) in events"
                        :key="'circle'+index"
                        :center="event.position"
                        :options="{
                            strokeColor: '#000',
                            strokeOpacity: 0,
                            strokeWeight: 0,
                            fillColor: '#ff6ada',
                            fillOpacity: 0.25,
                            radius: 500
                            }"
                        @click="panTo(event.position)"
                      ></GmapCircle> -->
                    </GmapMap>
                  </div>
                </div>
              </div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card-title>
    <v-card-title class="white--text hidden-md-and-up">
      <v-dialog v-model="direction" temporary max-width="600px">
        <template v-slot:activator="{ on }">
          <v-btn  rounded color="indigo" small v-on="on">{{ $t('map_direction') }}</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('map_location') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <div class="container">
                <div class="columns" style="padding-bottom: 0px; margin-bottom: 0px;">
                  <div class="column is-8">
                    <GmapMap
                      :center="location"
                      :options="{
                        zoomControl: true,
                        mapTypeControl: false,
                        scaleControl: false,
                        streetViewControl: false,
                        rotateControl: false,
                        fullscreenControl: true,
                        disableDefaultUi: false
                      }"
                      :zoom="14"
                      map-type-id="terrain"
                      style="width: 500px; height: 300px"
                    >
                      <GmapMarker
                        :key="'marker'+index"
                        v-for="(m, index) in markers"
                        :position="m.position"
                        :clickable="true"
                        :draggable="true"
                        @click="center=m.position"
                      />
                      <!-- <GmapCircle
                        v-for="(event, index) in events"
                        :key="'circle'+index"
                        :center="event.position"
                        :options="{
                            strokeColor: '#000',
                            strokeOpacity: 0,
                            strokeWeight: 0,
                            fillColor: '#ff6ada',
                            fillOpacity: 0.25,
                            radius: 500
                            }"
                        @click="panTo(event.position)"
                      ></GmapCircle> -->
                    </GmapMap>
                  </div>
                </div>
              </div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card-title>
  </span>
</template>

<script>
  import {gmapApi} from 'vue2-google-maps'

  export default {
    name: 'map',
    data: () => ({
      mapit: null,
      markers: [
        {
          position: {
            lng: 34.77,
            lat: 32.09
          }
        },
        {
          position: {
            lng: 34.78,
            lat: 32.08
          }
        }
      ],
      direction: false,
      location: {
        lng: 34.77,
        lat: 32.09
      }
    }),
    computed: {
      google: gmapApi
    }
  }
</script>